import React, { useState } from "react";

import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";


const TeamCard4= () => {
  const [active, setActive] = useState(0);

  const team = [
    {
      img: "https://picsum.photos/400/550?random=501",
      name: "Andrew Rathore",
      role: "Pet Caring",
      socials: [
        { icon: <FaFacebookF />, link: "#" },
        { icon: <FaTwitter />, link: "#" },
        { icon: <FaInstagram />, link: "#" },
        { icon: <FaLinkedinIn />, link: "#" },
      ],
    },
    {
      img: "https://picsum.photos/400/550?random=502",
      name: "John Deo",
      role: "Pet Veterinary",
      socials: [
        { icon: <FaFacebookF />, link: "#" },
        { icon: <FaTwitter />, link: "#" },
        { icon: <FaInstagram />, link: "#" },
        { icon: <FaLinkedinIn />, link: "#" },
        ],
    },
    {
      img: "https://picsum.photos/400/550?random=503",
      name: "Mark Joseph",
      role: "Pet Caring",
      socials: [
       { icon: <FaFacebookF />, link: "#" },
        { icon: <FaTwitter />, link: "#" },
        { icon: <FaInstagram />, link: "#" },
        { icon: <FaLinkedinIn />, link: "#" },
         ],
    },
    {
      img: "https://picsum.photos/400/550?random=504",
      name: "Albert Mahone",
      role: "Pet Grooming",
      socials: [
        { icon: <FaFacebookF />, link: "#" },
        { icon: <FaTwitter />, link: "#" },
        { icon: <FaInstagram />, link: "#" },
        { icon: <FaLinkedinIn />, link: "#" },
        ],
    },
  ];

  return (<>
    <div className="pet-team-container-tc4">
      {team.map((member, index) => (
        <div
          key={index}
          className={`pet-card-tc4 ${active === index ? "active" : ""}`}
          onMouseEnter={() => setActive(index)}
          onClick={() => setActive(index)}
        >
          <div className="pet-img-tc4-wrap">
            <img src={member.img} alt={member.name} />
          </div>

          <h3>{member.name}</h3>
          <p className="role">{member.role}</p>

          <div className="social-bar-tc4">
            {member.socials.map((ico, i) => (
              <a key={i} href={ico.link}>
                {ico.icon}
              </a>
            ))}
          </div>
        </div>
      ))}
    </div>
    <style>{`.pet-team-container-tc4 {
  display: flex;
  justify-content: center;
  gap: 45px;
  flex-wrap: wrap;
  padding: 50px 0;
}

.pet-card-tc4 {
  width: 240px;
  text-align: center;border-radius:15px;
  cursor: pointer;
  filter: brightness(0.6);
  transition: all 0.4s ease;
  position: relative;
}

.pet-card-tc4.active,
.pet-card-tc4:hover {
  transform: scale(1.15);
  box-shadow: 0 0 25px rgba(0, 123, 255, 0.05);
  filter: brightness(1);
}

.pet-img-tc4-wrap {
  width: 140px;
  height: 200px;
  border-radius: 10px;
  overflow: hidden;
  border: 0px solid transparent;
  transition: 0.4s;
}

.pet-card-tc4.active .pet-img-tc4-wrap {
  border-color: rgba(144, 202, 249,1);
}

.pet-img-tc4-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.role {
  color: #666;
  font-size: 14px;
  margin-bottom: 10px;
}


/* social icons sliding up */
.social-bar-tc4 {
 opacity:0;
 
  transition: opacity 0.3s ease;
}
.social-bar-tc4 {
  position: absolute;
  top: 0px; /* above image */
  left: 50%;
  transform: translateX(-50%) ;
  width: 140px; /* width of arc */
  height: 70px; /* arc height */
  display: flex;
  justify-content: space-around;
  pointer-events: auto;
}

.social-bar-tc4 a {
  width: 28px;
  transition: opacity 0.3s ease;
  height: 28px;
  background: #ffffff;
  color: #222222;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 12px;
  text-decoration: none;
  position: absolute;
}
.pet-card-tc4:hover .social-bar-tc4{opacity:1;}
/* Semi-circle positioning */
.social-bar-tc4 a:nth-child(1) {
  top: 10px;
  right: -15px;
}

.social-bar-tc4 a:nth-child(2) {
  top: 50px;
  right: -15px;
}

.social-bar-tc4 a:nth-child(3) {
  top: 90px;
  right: -15px;
}

.social-bar-tc4 a:nth-child(4) {
  top: 130px;
  right: -15px;
}

/* Hover animation */
.social-bar-tc4 a:hover {
 
  background: rgba(144, 202, 249,1);
}

/* Responsive */
@media (max-width: 768px) {
  .pet-card-tc4 {
    width: 180px;
  }
  .pet-img-tc4-wrap {
    width: 180px;
    height: 210px;
  }
}
`}</style>
    </>
  );
};

export default TeamCard4;
